import React from 'react';

import {HeroImage} from 'src/components/shared';
import {CATEGORY, SERIES} from 'src/routes/paths';
import {editorial as copy} from 'src/utils/copy';

import {SanityEditorial} from 'types/generated';

type HeroHeaderProps = SanityEditorial & {
  backgroundColor: string;
  url: string;
};

export const HeroHeader: React.FC<HeroHeaderProps> = props => {
  const separatorColor =
    props.backgroundColor == 'bg-white' || props.backgroundColor == '' ? 'border-black' : 'border-white';
  const isCatAndSeries = props.editorialCategory !== null ? 'border-l  ml-4 pl-4 ' : '';
  const eyebrowClasses = 'type-eyebrow block';

  return (
    <div className="col-span-full md:col-span-11 md:col-start-2" data-module="article-hero">
      <div className="flex mb-2 lg:mb-4">
        {props.editorialCategory?.slug ? (
          <a href={`${CATEGORY}/${props.editorialCategory.slug.current}`} className={`link-eyebrow ${eyebrowClasses}`}>
            {props.editorialCategory.title}
          </a>
        ) : props.category ? (
          <span className="type-eyebrow block">{props.category}</span>
        ) : null}

        {props.article_related_series && (
          <a
            href={`${SERIES}/${props.article_related_series?.slug?.current}`}
            className={['link-eyebrow', eyebrowClasses, isCatAndSeries, separatorColor].join(' ')}
          >
            {props.article_related_series.title}
          </a>
        )}

        {!props.article_related_series && props.seriesName && (
          <span className={[eyebrowClasses, isCatAndSeries, separatorColor].join(' ')}>{props.seriesName}</span>
        )}
      </div>
      <h1 className="type-alpha">{props.title}</h1>
      {!!props.heroImage && !!props.heroImage.asset?.url && (
        <HeroImage
          id={props.heroImage.asset?.assetId}
          src={props.heroImage?.asset?.url}
          altText={props.heroImage?.altText || ''}
        />
      )}
      <div className="flex justify-between mt-3 flex-col-reverse md:flex-row text-gray">
        <div className="flex md:items-center mt-5 md:mt-0 flex-wrap bg-ivory rounded-md px-3 py-2 self-start flex-col md:flex-row ">
          <p className={props.publishDate ? 'md:border-dark-gold md:border-r md:mr-2 md:pr-2 mb-1 md:mb-0' : ''}>
            <span className="type-sm-p">By </span>
            {!!props.articleAuthor?.name && (
              <a
                href={`/authors/${props.articleAuthor?.slug?.current}`}
                className="type-lota text-green-dark link-eyebrow transation-all ease-in-out duration-500"
              >
                {props.articleAuthor.name}
              </a>
            )}

            {props.articleAuthor?.name == undefined && props.byline !== undefined ? (
              <span className="type-lota text-green-dark">{props.articleAuthor?.name ?? props.byline}</span>
            ) : null}
          </p>
          {!!props.publishDate && <time className="type-sm-p">{copy.mostRecentPublishDate(props.publishDate)}</time>}
        </div>
        {!!props.heroImage && !!props.heroImage.asset?.url && (
          <span className="type-xs-p text-right">
            {props.heroImage.attribution} {props.heroImage.attribution && props.heroImage.caption ? '/' : ''}{' '}
            {props.heroImage.caption}
          </span>
        )}
      </div>
    </div>
  );
};
